import React from 'react';
import PropTypes from 'prop-types';

import { Cover, Image, Layout, SectionOurStory, SectionPress, SectionTextMedia, SEO } from 'components';
import { routes } from 'utils/routes';
import { cta } from 'utils/cta';
import { media } from "utils/media";

// Content
import contentSEO from "cms/content/about-seo.yml";
import contentCover from "cms/content/about-cover.yml";
import contentSections from "cms/content/about-sections.yml";
import contentMilestones from "cms/content/about-milestones.yml";
import contentFounders from "cms/content/about-founders.yml";
import contentDna from "cms/content/about-dna.yml";

const AboutPage = ({ pageContext: { locale }, location }) => (
  <Layout locale={locale}>
    <SEO
      title={contentSEO.title}
      description={contentSEO.description}
      lang={locale}
      keywords={contentSEO.keywords}
      location={location}
      image={contentSEO.socialImage}
    />

    <Cover
      title={contentCover.title}
      image={{ url: media(contentCover.image), alt: 'About Straight Teeth Direct™' }}
      button={{ label: cta.getStarted, ...routes.getStarted }}
    />

    {contentSections.sections.map(({ enabled, title, text, image, className, reverse, videoUrl, isVideo }) => (
      <SectionTextMedia
        enabled={enabled}
        title={title}
        text={text}
        image={{ url: media(image), alt: title }}
        className={className}
        reverse={reverse}
        videoUrl={videoUrl}
        isVideo={isVideo}
      />
    ))} 

    <SectionOurStory />

    <div className='section-founders'>
      <Image url='pages/about_founders.jpg' alt='Straight Teeth Direct™ Founders' />
      <div className='flex fw'>
        {contentFounders.founders.map(({ name, title }) => (
          <div className='founder-wrapper'>
            <h3>{name}</h3>
            <p>{title}</p>
          </div>
        ))}
      </div>
    </div>

    <div className='section-dna'>
      <div className='dna-content'>
        <h2 className='mb-20'>{contentDna.title}</h2>
        <p>{contentDna.subtitle}</p>
      </div>
      <div className='title-dna circle'>{contentDna.dna1}</div>
      <div className='title-dna triangle'>{contentDna.dna2}</div>
      <div className='title-dna losange'>{contentDna.dna3}</div>
      <div className='title-dna hexagon'><div className='hexagon-shape' />{contentDna.dna4}</div>
      <div className='title-dna square'>{contentDna.dna5}</div>
    </div>

    <SectionPress />

    <div className='section-milestones bg-gray-dotted'>
      <h2 className='section-title'>{contentMilestones.title}</h2>
      <div className='section-logos'>
        {contentMilestones.milestones.map(({ image, caption }) => (
          <Image url={media(image)} alt={caption} />
        ))}
      </div>
    </div>
  </Layout>
);

AboutPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default AboutPage;
